/**
 * Validates if a string is a valid domain format
 * @param domain The domain to validate
 * @returns boolean indicating if the domain is valid
 */
export function isValidDomain(domain: string): boolean {
  // Basic domain validation (allows subdomains)
   
  const domainRegex = /^([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/;
  return domainRegex.test(domain);
}
